import { PrimaryButton, SecondaryButton } from '../components/Button';
import { BottomSheet } from '../components/BottomSheet';
import { copy } from '../copy';
import { stopCounts, visibleStops, isStopHandled } from '../state/route';
import { selectQueueCount, useAppStore } from '../state/store';

/** D5 · D4-sheet · I2 · J4-uitlogsheet · B3-beginschermhint. */
export function Sheets() {
  const sheet = useAppStore((s) => s.sheet);
  const route = useAppStore((s) => s.route);
  const notTakenParcel = useAppStore((s) => s.notTakenParcel);
  const queueCount = useAppStore(selectQueueCount);
  const closeSheet = useAppStore((s) => s.closeSheet);
  const navigate = useAppStore((s) => s.navigate);
  const recordAction = useAppStore((s) => s.recordAction);
  const logout = useAppStore((s) => s.logout);
  const setPrefs = useAppStore((s) => s.setPrefs);

  if (sheet === null) return null;

  if (sheet === 'pickup') {
    return (
      <BottomSheet title={copy.pickupSheet.title} onDismiss={closeSheet}>
        <p className="sheet__text">{copy.pickupSheet.body}</p>
        <PrimaryButton
          onClick={() => {
            void recordAction({ type: 'route.startPickup', request: {} }).then(() =>
              navigate('load'),
            );
          }}
        >
          {copy.pickupSheet.confirm}
        </PrimaryButton>
        <SecondaryButton onClick={closeSheet}>{copy.pickupSheet.cancel}</SecondaryButton>
      </BottomSheet>
    );
  }

  if (sheet === 'notTaken') {
    return (
      <BottomSheet title={copy.load.notTakenTitle} onDismiss={closeSheet}>
        <p className="sheet__text">{copy.load.notTakenBody}</p>
        <PrimaryButton
          onClick={() => {
            if (notTakenParcel) {
              void recordAction({
                type: 'parcel.notTaken',
                request: { parcelNumber: notTakenParcel },
                subject:
                  route?.stops.find((stop) =>
                    stop.parcels.some((parcel) => parcel.parcelNumber === notTakenParcel),
                  )?.partnerName ?? null,
              });
            }
            closeSheet();
          }}
        >
          {copy.load.notTakenConfirm}
        </PrimaryButton>
        <SecondaryButton onClick={closeSheet}>{copy.load.notTakenCancel}</SecondaryButton>
      </BottomSheet>
    );
  }

  if (sheet === 'complete' && route) {
    const counts = stopCounts(route);
    const open = visibleStops(route).filter((stop) => !isStopHandled(stop.status));
    const body =
      open.length > 0
        ? copy.ret.sheetOpen(open.length, open.map((stop) => stop.partnerName).join(', '))
        : counts.failed === 0
          ? copy.ret.sheetAllDelivered(counts.delivered)
          : copy.ret.sheetMixed(counts.delivered, counts.failed);

    return (
      <BottomSheet title={copy.ret.sheetTitle} onDismiss={closeSheet}>
        <p className="sheet__text">{body}</p>
        {queueCount > 0 ? <p className="sheet__text">{copy.ret.sheetQueue(queueCount)}</p> : null}
        {open.length > 0 && open[0] ? (
          <SecondaryButton
            onClick={() => {
              closeSheet();
              navigate('fail', open[0]!.id);
            }}
          >
            {copy.ret.sheetFailFirst}
          </SecondaryButton>
        ) : null}
        <PrimaryButton
          onClick={() => {
            void recordAction({ type: 'route.complete', request: {} }).then(() => navigate('done'));
          }}
        >
          {copy.ret.sheetConfirm}
        </PrimaryButton>
        <SecondaryButton onClick={closeSheet}>{copy.ret.sheetCancel}</SecondaryButton>
      </BottomSheet>
    );
  }

  if (sheet === 'logout') {
    return (
      <BottomSheet title={copy.settings.logoutTitle} onDismiss={closeSheet}>
        {queueCount > 0 ? <p className="sheet__text">{copy.settings.logoutQueue(queueCount)}</p> : null}
        <PrimaryButton onClick={() => void logout()}>{copy.settings.logoutConfirm}</PrimaryButton>
        <SecondaryButton onClick={closeSheet}>{copy.settings.logoutCancel}</SecondaryButton>
      </BottomSheet>
    );
  }

  if (sheet === 'install') {
    return (
      <BottomSheet
        title={copy.install.title}
        onDismiss={() => {
          void setPrefs({ iosInstallHintSeen: true });
          closeSheet();
        }}
      >
        <p className="sheet__text">{copy.install.body}</p>
        <PrimaryButton
          onClick={() => {
            void setPrefs({ iosInstallHintSeen: true });
            closeSheet();
          }}
        >
          {copy.install.understood}
        </PrimaryButton>
      </BottomSheet>
    );
  }

  return null;
}
